import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Attending } from '../../model/attending';
import {MaterializeAction} from 'angular2-materialize';

@Component({
  selector: 'tx-finish-attending',
  templateUrl: './finish-attending.component.html',
  styleUrls: ['./finish-attending.component.css']
})
export class FinishAttendingComponent implements OnInit {

  _attending: Attending;
  _authenticatedUser: any;
  _hasScore: boolean;
  _canFinish: boolean;
  _loading: boolean;

  modalActions = new EventEmitter<string|MaterializeAction>();

  @Output() txUpdateAttending: EventEmitter<void> = new EventEmitter();
  @Output() txFinish: EventEmitter<void> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  @Input()
  set attending(attending) {
    this._attending = attending;
  }

  get attending() {
    return this._attending;
  }

  @Input()
  set authenticatedUser(authenticatedUser) {
    this._authenticatedUser = authenticatedUser;
  }

  get authenticatedUser() {
    return this._authenticatedUser;
  }

  @Input()
  set canFinish(canFinish) {
    this._canFinish = canFinish;
  }

  get canFinish() {
    return this._canFinish;
  }

  @Input()
  set loading(loading) {
    this._loading = loading;
  }

  get loading() {
    return this._loading;
  }

  openModal() {
    this.modalActions.emit({ action: 'modal', params: ['open'] });
  }

  isTechnicianScoreGiven() {
    return this.attending.technicianScore.score || this._hasScore;
  }

  updateAttending() {
    this._hasScore = true;
    this.txUpdateAttending.emit();
  }

  finish() {
    this.txFinish.emit();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/finish-attending/finish-attending.component.ts